import {
  Edit,
  ImageInput,
  SelectInput,
  SimpleForm,
  TextInput,
} from "react-admin";
import ApcMediaField from "../../common/ApcMediaField";

const year = [
  
  {
    id: "Y2025",
    label: "2025",
  },
];

const source = [
  {
    id: "AHA",
    label: "AHA",
  },
  {
    id: "AADA",
    label: "AADA",
  },
];

const EditPdf = (props: any) => {
  return (
    <Edit {...props} title={<title />}>
      <SimpleForm>
        <ImageInput
          label="Thumbnail"
          source="thumbnail"
          fullWidth
          accept="image/*"
          format={(src) =>
            typeof src == "string" ? { src, type: props } : src
          }
        >
          <ApcMediaField source="src" />
        </ImageInput>

        <TextInput label="Title" source="title" multiline fullWidth required />
        <TextInput
          label="Description"
          source="description"
          multiline
          fullWidth
          required
        />

        <SelectInput
          source="year"
          label="Year"
          defaultValue={{ id: "Y2023", label: "2023" }}
          choices={year}
          optionText="label"
          optionValue="id"
        />

        <SelectInput
          source="source"
          label="Source"
          choices={source}
          optionText="label"
          optionValue="id"
        />
        <TextInput
          label="Priority"
          source="priority"
          multiline
          fullWidth
          required={true}
        />
        <TextInput
          source="mediaType"
          label="Media Type"
          defaultValue={"Pdf"}
          disabled
          hidden={true}
        />

        <ImageInput
          label="URL pdf"
          source="url"
          fullWidth
          format={(src: any) =>
            typeof src === "string" ? { src, type: props } : src
          }
        >
          <ApcMediaField source="src" />
        </ImageInput>
      </SimpleForm>
    </Edit>
  );
};

export default EditPdf;
